import { Stack, Box, CircularProgress, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import appLoaderLang from '../langs/appLoaderLang';
type AppLoaderPageProps = {
	title?: string;
};
const AppLoaderPage = (props: AppLoaderPageProps) => {
	const theme = useTheme();
	const { t } = useTranslation();

	const { title } = props;
	return (
		<Stack alignItems="center" justifyContent="center" sx={{ height: '100vh', minHeight: '100vh' }}>
			<Box sx={{ color: 'white', textAlign: 'center', position: 'relative' }}>
				<Box>
					<CircularProgress color="secondary" disableShrink />
				</Box>
				<Box sx={{ margin: '30px', color: theme.palette.primary.main }}>
					{title ?? t(appLoaderLang.loading.tag)}
				</Box>
			</Box>
		</Stack>
	);
};

export default AppLoaderPage;
